import { FieldType } from 'modules/domains';

export const isIntegerFieldType = (type?: FieldType): type is FieldType.INTEGER =>
  type === FieldType.INTEGER;
